import {EnvironmentImageRequestParams} from "../../models/image/environment-image-request-params";

export class InvitationBackgroundImageRequestParams extends EnvironmentImageRequestParams {
  constructor() {
    super({});

    this._resourceName = `/assets/Desktop_Invitation_BG.png`;
  }
}
